import { z } from 'zod'
import NiSquircle from '@/ui/icons/nexture/ni-squircle'
import { ButtonLink } from '@/ui/kit/ButtonLink'
import { Empty } from './Empty'

const uuid = z.uuid()

/** Id de rota que nem chega a ser uuid não vai ao servidor: é link quebrado. */
export function ehIdValido(id: string): boolean {
  return uuid.safeParse(id).success
}

export interface NaoEncontradoProps {
  title: string
  hint: string
  /** Para onde voltar. Sempre há saída. */
  to: '/app' | '/app/pacientes'
  label: string
}

/**
 * O que a URL aponta não existe: link errado, item apagado ou de outra conta.
 * Tentar de novo não resolve, então o único botão leva de volta.
 */
export function NaoEncontrado({ title, hint, to, label }: NaoEncontradoProps) {
  return (
    <Empty
      icon={NiSquircle}
      title={title}
      hint={hint}
      action={
        <ButtonLink to={to} variant="contained">
          {label}
        </ButtonLink>
      }
    />
  )
}
